
export type StringConvertProc = (srcText: string) => (string)

// 半角大文字英数字
export const toUpperAlphaNum: StringConvertProc = (srcText: string) => {
  const normalized = srcText.normalize("NFKC")
  const upperCaseText = normalized.toUpperCase()
  return upperCaseText
}
